import React from "react";
const IconGeolocation = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
    <path
      d="M16 10C16 13.3137 13.3137 16 10 16M16 10C16 6.68629 13.3137 4 10 4M16 10H19M10 16C6.68629 16 4 13.3137 4 10M10 16V19M4 10C4 6.68629 6.68629 4 10 4M4 10H1M10 4V1M12 10C12 11.1046 11.1046 12 10 12C8.89543 12 8 11.1046 8 10C8 8.89543 8.89543 8 10 8C11.1046 8 12 8.89543 12 10Z"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);
export default IconGeolocation;
